import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center overflow-hidden" aria-labelledby="hero-title">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20Korean%20manhwa%20illustration%20style%20background%20with%20warm%20crimson%20and%20dark%20charcoal%20gradient%2C%20subtle%20ink%20wash%20texture%2C%20geometric%20composition%2C%20atmospheric%20dramatic%20lighting%2C%20painterly%20brush%20strokes%2C%20cinematic%20mood%2C%20no%20text%2C%20clean%20artistic%20backdrop&width=1800&height=720&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫漫画网站 - 海量正版漫画在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 text-accent-200 text-xs font-medium px-3 py-1.5 rounded-full mb-6">
              <i className="ri-sparkling-line text-xs"></i>
              正版授权 · 每日更新
            </span>
            <h1 id="hero-title" className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-tight mb-5">
              海量正版韩漫
              <br />
              免费在线阅读
            </h1>
            <p className="text-base md:text-lg text-background-200/90 leading-relaxed mb-8 max-w-lg">
              汇集全网热门韩国漫画，高清画质、流畅体验。<strong>每日更新</strong>热门连载，让每一页都成为享受。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <Link
                to="/category/rexue"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-7 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                立即阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/about"
                className="bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 font-medium px-7 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>

            <div className="flex items-center gap-6 mt-10">
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">12,800+</p>
                <p className="text-xs text-background-300 mt-1">正版漫画</p>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">3,200万+</p>
                <p className="text-xs text-background-300 mt-1">累计用户</p>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">每日更新</p>
                <p className="text-xs text-background-300 mt-1">从不间断</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}